import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@common';

@Injectable({ providedIn: 'root' })
export class QueryParamsService {
  constructor(@Inject(WINDOW) private readonly window: Window) {}

  get queryParams(): URLSearchParams {
    return new URLSearchParams(this.window.location.search);
  }

  getParam(name: string): string | null {
    return this.queryParams.get(name);
  }

  getAll(name: string): string[] {
    return this.queryParams.getAll(name);
  }
}
